import React from 'react';
import PropTypes from 'prop-types';
//import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {TweenLite, Elastic, Bounce, Linear} from 'gsap';
import gsap from 'gsap-react-plugin';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as dialogPopupActions from '../../actions/dialogPopupActions';
import * as keyboardConstants from '../../constants/keyboardConstants';
import * as objectConstants from '../../constants/objectConstants';
import * as appHelper from '../../helpers/appHelper';
import * as dataHelper from '../../helpers/dataHelper';

//import toastr from 'toastr';

export class AssetDialog extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            currentOpacity: 0,
            currentTop: 0,
            isOpenOpacity: 1,
            isOpenTop: 0,
            isClosedOpacity: 0,
            isClosedTop: 0,
            assetDialog: this.props.assetDialog,
            tabbableElements: [],
            assetViewed: false,
            isOpen: false,
            elementInterval: {},
            guid: dataHelper.createGuid()

        };
        this.openDialog = this.openDialog.bind(this);
        this.isOpenFunc = this.isOpenFunc.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.isClosedFunc = this.isClosedFunc.bind(this);
        this.onAssetViewed = this.onAssetViewed.bind(this);
        this.setTabbableElements = this.setTabbableElements.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.setInitialFocus = this.setInitialFocus.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.setElementInterval = this.setElementInterval.bind(this);

        this.assetDialog = React.createRef();
    }

    componentDidMount() {
        window.addEventListener("keydown", this.onKeyDown);
        window.addEventListener("keyup", this.onKeyUp);
        this.setElementInterval();
        let func = this.openDialog;
        setTimeout(function () {

            func();
        }, 200);

    }

    componentDidUpdate() {
        if (!this.state.isOpen && this.state.assetDialog.isOpen) {
            this.setInitialFocus();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.onKeyDown);
        window.removeEventListener("keyup", this.onKeyUp);
        clearInterval(this.state.elementInterval);
    }

    setElementInterval(){
        let interval = setInterval(this.setTabbableElements, 2000);
        this.setState({elementInterval: interval});
    }

    openDialog() {
        if(appHelper.isDefined(this) && this !== null) {

            TweenLite.to(this, objectConstants.DIALOG_DURATION, {
                state: {
                    currentOpacity: this.state.isOpenOpacity,
                    currentTop: this.state.isOpenTop,
                    ease: Linear.easeIn
                }
            }).eventCallback("onComplete", this.isOpenFunc);
        }
    }

    isOpenFunc() {
        this.setState(
            {
                assetDialog: Object.assign({}, this.state.assetDialog, {
                    isOpen: true,
                    currentClassState: this.state.assetDialog.classStates.isOpen
                })
            }
        );
    }

    closeDialog() {
        let focusEl = document.getElementById(this.state.assetDialog.config.sourceId);
        if(appHelper.isDefined(focusEl)){
            focusEl.focus();
        }
        this.setState(
            {
                assetDialog: Object.assign({}, this.state.assetDialog, {
                    isOpen: false,
                    currentClassState: this.state.assetDialog.classStates.isClosed
                })
            }
        );
        if(appHelper.isDefined(this) && this !== null) {

            TweenLite.to(this, objectConstants.DIALOG_DURATION, {
                state: {
                    currentOpacity: this.state.isClosedOpacity,
                    currentTop: this.state.isClosedTop,
                    ease: Linear.easeIn
                }, delay: 0.5
            }).eventCallback("onComplete", this.isClosedFunc);
        }
    }

    isClosedFunc() {
        this.props.actions.removeAssetDialog();
        this.state.assetDialog.config.onClose(this.state.assetViewed);

    }

    onAssetViewed() {
        this.setState({assetViewed: true});
    }

    onKeyDown(event) {
        let shiftPressed = this.state.shiftPressed;
        let tabPressed = this.state.tabPressed;

        if (event.which === keyboardConstants.ESCAPE_KEY) {
            event.preventDefault();
            this.closeDialog();
        }

        if (event.which === keyboardConstants.TAB_KEY) {
            tabPressed = true;
            this.setState({
                tabPressed: tabPressed
            });
        }

        if (event.which === keyboardConstants.SHIFT_KEY) {
            shiftPressed = true;
            this.setState({
                shiftPressed: shiftPressed
            });
        }
    }

    onKeyUp(event) {
        let activeItem = document.activeElement;
        let activeItemId = activeItem.id;
        //console.log(activeItemId);
        if (activeItemId === this.state.tabbableElements[0].id) {
            //go to last
            //console.log(this.state.tabbableElements[this.state.tabbableElements.length - 2]);
            this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
        } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
            this.state.tabbableElements[1].focus();
        }

        this.setState({
            tabPressed: false,
            shiftPressed: false
        });
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.closeDialog();
        }
    }

    setTabbableElements() {
        let dialog = this.assetDialog.current;
        if(appHelper.isEleDefined(dialog)) {
            this.setState({tabbableElements: Object.assign([], dataHelper.getAllTabbableElements(dialog))});
            if (!this.state.isOpen && this.state.assetDialog.isOpen) {

                this.setInitialFocus();
            }
        }
    }

    setInitialFocus() {
        let initFocusEl = this.state.tabbableElements[1];
        if (appHelper.isDefined(initFocusEl)) {
            this.state.tabbableElements[1].focus();
            this.setState({isOpen: true});
        }
    }

    render() {
        return (

            <div className={`dialog-page ${this.state.assetDialog.currentClassState}`}
                 style={{opacity: this.state.currentOpacity}} role="dialog" aria-modal={this.state.isDialog}
                 ref={this.assetDialog} id="assetDialog">
                <div id={`firstTabIndex_asset_dialog_${this.state.guid}`} tabIndex="0" role="button"/>
                <div className={`${this.state.assetDialog.className} ${this.state.assetDialog.config.theme}`}>
                    {
                        this.state.assetDialog.config.showCloseBtn
                            ?
                            <div className="dialog-header">
                                <p> {this.state.assetDialog.config.title}</p>
                                <div className={`close-btn icon-first icons8-multiply`} role="link" tabIndex="0"
                                     onClick={this.closeDialog} onKeyDown={this.setKeyboardAccessibility}
                                     ref="closeAssetDialogBtn">
                                    Close
                                </div>
                            </div>
                            :
                            null
                    }

                    <div className="dialog-body">
                        {this.state.assetDialog.config.childComponents.map(component =>
                            <div key={"container_" + component.id} className="component-seperator">
                                {component.componentProps != null
                                    ? <component.childComponent key={component.id} {...component.componentProps}
                                                                onAssetViewed={this.onAssetViewed}
                                                                closeDialog={this.closeDialog}/>
                                    : <component.childComponent key={component.id} onAssetViewed={this.onAssetViewed}
                                                                closeDialog={this.closeDialog}/>
                                }
                            </div>
                        )}
                    </div>
                </div>
                <div id={`lastTabIndex_assetDialog_${this.state.guid}`} tabIndex="0" role="button"/>
            </div>
        );

    }
}

AssetDialog.propTypes = {
    assetDialog: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

//Pull in the React Router context so router is available on this.context.router.
AssetDialog.contextTypes = {
    router: PropTypes.object
};

//Init
function mapStateToProps(state, ownProps) {
    return {
        assetDialog: state.assetDialog
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetDialog);



/** WEBPACK FOOTER **
 ** ./src/components/dialogs/AssetDialog.js
 **/